import { Button, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ArrowLeftOutlined, ReloadOutlined } from '@ant-design/icons';
import LoadingButton from '../../../../components/@extended/LoadingButton';
import { buttonIconMotionSx, quietActionSx } from '../../../../components/ui/styleKit';
import { useSimulateActions, useSimulateResult } from '../SimulateTradeContext';
import { SIMULATE_COPY } from '../content';
import { simulatePrimaryActionSx } from '../styles';

const { actions } = SIMULATE_COPY;

export const EditOrderButton = () => {
  const theme = useTheme();
  const { loading } = useSimulateResult();
  const { editOrder } = useSimulateActions();
  return (
    <Button
      variant="outlined"
      startIcon={<ArrowLeftOutlined />}
      onClick={editOrder}
      disabled={loading}
      sx={{ ...quietActionSx(theme), ...buttonIconMotionSx }}
    >
      {actions.edit}
    </Button>
  );
};

/** Re-runs the same order; the label says why (again after a result, retry after a failure). */
export const RerunButton = ({ label }: { label: string }) => {
  const theme = useTheme();
  const { loading } = useSimulateResult();
  const { submit } = useSimulateActions();
  return (
    <LoadingButton
      variant="contained"
      loading={loading}
      loadingPosition="end"
      endIcon={<ReloadOutlined />}
      onClick={submit}
      sx={simulatePrimaryActionSx(theme)}
    >
      {label}
    </LoadingButton>
  );
};

/** Result footer: back to the form, or run the same order again. */
export const SimulateResultActions = () => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
    <EditOrderButton />
    <RerunButton label={actions.again} />
  </Stack>
);
